import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ArrowRight, Anchor } from 'lucide-react';

const Home = () => {
  const { t } = useTranslation();

  return (
    <div className="page-home">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <div className="hero-icon">
            <Anchor size={60} />
          </div>
          <h1 className="hero-title">{t('hero.title')}</h1>
          <p className="hero-subtitle">{t('hero.subtitle')}</p>
          <p className="hero-description">{t('hero.description')}</p>
          <div className="hero-actions">
            <Link to="/projects" className="btn-primary">
              {t('nav.projects')}
              <ArrowRight size={20} />
            </Link>
            <Link to="/contact" className="btn-secondary">
              {t('nav.contact')}
            </Link>
          </div>
        </div>
      </section>

      {/* Quick Stats */}
      <section className="stats-section">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-number">6+</div>
              <div className="stat-label">Years Experience</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">13+</div>
              <div className="stat-label">Completed Projects</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">3</div>
              <div className="stat-label">Vessel Categories</div>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Services */}
      <section className="featured-section">
        <div className="container">
          <h2 className="section-title">{t('services.title')}</h2>
          <p className="section-subtitle">{t('services.subtitle')}</p>
          
          <div className="featured-grid">
            <div className="featured-card">
              <h3>{t('services.service1.title')}</h3>
              <p>{t('services.service1.description')}</p>
            </div>
            <div className="featured-card">
              <h3>{t('services.service2.title')}</h3>
              <p>{t('services.service2.description')}</p>
            </div>
            <div className="featured-card">
              <h3>{t('services.service3.title')}</h3>
              <p>{t('services.service3.description')}</p>
            </div>
          </div>

          <div className="featured-actions">
            <Link to="/services" className="btn-outline">
              {t('nav.services')}
              <ArrowRight size={18} />
            </Link>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>{t('hero.cta.title')}</h2>
            <p>{t('hero.cta.description')}</p>
            <Link to="/about" className="btn-primary">
              {t('hero.cta.button')}
              <ArrowRight size={20} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
